import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const FormControl = lazyImport(() => import('@mui/material/FormControl'))
export const InputLabel = lazyImport(() => import('@mui/material/InputLabel'))
